import Title from "components/title";
import { FunctionComponent } from "react";
import {
  StyledBlock,
  StyledButton,
  StyledHeader,
  StyledLocale,
  StyledLocaleSwitcher,
} from "./header.styles";
import { faUser } from "components/icon-library";
import { useNavigate } from "react-router";
import { useList } from "stores/hooks/list";
import { useTranslate } from "stores/hooks/translation";
import { useLocale, useLocales } from "stores/hooks/locale";
import { getTranslations } from "lib/translation";
import { changeLocale } from "stores/actions/locale";

interface HeaderProps {
  title: string;
}

const Header: FunctionComponent<HeaderProps> = ({ title }) => {
  const navigate = useNavigate();
  const translate = useTranslate();
  const list = useList();
  const locale = useLocale();
  const locales = useLocales();

  if (!list) {
    return null;
  }

  return (
    <StyledHeader>
      <Title>{title}</Title>
      <StyledBlock>
        <StyledLocaleSwitcher>
          {locales.map((loc) => {
            const translation = getTranslations(loc);
            return (
              <StyledLocale
                key={loc}
                onClick={() => changeLocale(loc)}
                $active={loc === locale}
              >
                {translation[`show_in_locale_${loc}`]}
              </StyledLocale>
            );
          })}
        </StyledLocaleSwitcher>

        <StyledButton
          type="tertiary"
          preIcon={faUser}
          onClick={() => navigate(`/user/list/${list.uuid}/login`)}
        >
          {translate("shared_login")}
        </StyledButton>
      </StyledBlock>
    </StyledHeader>
  );
};

export default Header;
